import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import '../styles/MainView.css'
import logoutIcon from '../images/logout.png'
import key from '../images/key.png'
import Login from './Login'
import Sidebar from './SidebarRegional'
import ContainerWidget from '../widgets/ContainerWidget'
import AlertMessage from '../widgets/AlertMessage'
import Dashboard from '../dashboard/Dashboard'
import ReportsRegional from '../reports/ReportsRegional'

class RegionalOfficerView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			site: null,
			showConfirmMessage: false
		}
		sessionStorage.setItem("sidebar-item", "calendar")
		this.handleSidebarEvent = this.handleSidebarEvent.bind(this)
		this.setReportView = this.setReportView.bind(this)
	}

	handleSidebarEvent(value) {
		sessionStorage.setItem("sidebar-item", value)
		switch(value) {
			case "dashboard":
				this.setState({content: <Dashboard />})
				break
			case "reports":
				this.setReportView()
		}
	}

	setReportView() {
		this.setState({content: <ContainerWidget title="REPORTS"
			content={<ReportsRegional/>} key="reports" />})
	}

	componentWillMount() {
		// this.setState({content: <Dashboard />})
		this.setReportView()
	}

	render() {
		return(<div id="main-view">
			<Header user={this.state.user} setSite={this.setSite} siteData={this.state.siteData} />
			<Sidebar type={"account-type"} onMenuItemClick={this.handleSidebarEvent} />
			<ContentPane content={this.state.content} onChangeBody={this.handleContentEvent} />
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
				}} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.setState({showConfirmMessage: false})
					}
					else {
						if(this.state.clusterSignal != null) {
							this.archiveCluster()
						}
						else if(this.state.siteSignal != null) {
							this.deleteSite()
						}
					}
				}} />}
		</div>)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
	}

	render() {
		const extName = (this.props.user.extension_name == null)? "": this.props.user.extension_name
		const mi = (this.props.user.middle_name == null)? "": this.props.user.middle_name
		const name = this.props.user.first_name + " " + mi + " " + this.props.user.last_name + " " + extName
		const view = <div id="header">
			<div id="header-site">
				<div id="title">LINKSFARMM MELA</div>
			</div>
			<div id="account-name">
				<div id="role">{this.props.user.role}</div>
				<ul><li class="drop">
					<button>{name.toUpperCase()}</button>
					<div class="dropdown">
						<div class="dropout">
							<ul>
								<li id="change-pw" onClick={() => {
									console.log("CHANGE PASSWORD")
								}}><span>
									<img src={key} />
									<label>CHANGE PASSWORD</label>
								</span></li>
								<li id="logout" onClick={() => {
									ReactDOM.render(<Login />, document.getElementById("app"))
								}}><span>
									<img src={logoutIcon} />
									<label>LOGOUT</label>
								</span></li>
							</ul>
						</div>
					</div>
				</li></ul>
			</div>
		</div>
		return(view)
	}
}

function ContentPane(props) {
	return(<div id="content-pane">
		{props.content}
	</div>)
}

export default RegionalOfficerView
